module.exports = __webpack_public_path__ + "static/media/design6.dc446420.png";